module.exports = __webpack_public_path__ + "img/clod-open.0bf008ec.svg";